import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { Title } from "../Components/Home/Title/Title";
import { Table } from "../Components/Home/Table/Table";
import { useDispatch } from "react-redux";
import { emptyOrders } from "../Store/Features/Order/orderSlice";
import { emptyChannel } from "../Store/Features/SingleChannel/SingleChannelSlice";
import { emptyProduct } from "../Store/Features/Product/productSlice";
import { emptyHooks } from "../Store/Features/WebHooks/SingleChannelHooks";

export const Home = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(emptyOrders());
    dispatch(emptyChannel());
    dispatch(emptyProduct());
    dispatch(emptyHooks());
  }, []);
  return (
    <Box className="main_container">
      <Title />
      <Table />
    </Box>
  );
};
